import { Dropdown } from "react-bootstrap";
import React, { useEffect, useState } from "react";

type Props<T extends { id: string }> = {
    items: T[],
    builder: (item: T, isSelected: boolean) => JSX.Element,
    format?: (item: T) => string,
    onSelected: (item?: T) => void,
    value?: string,
    placeholder?: string
}

export function CustomDropdown<T extends { id: string }>({ items, builder, format, onSelected, value, placeholder = "Select" }: Props<T>) {
    const [selected, setSelected] = useState<string | null>(value ?? null)

    const onSelect = (key: string | null) => {
        key = key == selected ? null : key
        setSelected(key)
        onSelected(items.find(e => e.id === key))
    }

    const formattedSelectedItem = () => {
        const item = items.find(e => e.id === selected)
        if (item) return format?.call(null, item) ?? ""
        return ""
    }

    useEffect(() => setSelected(value ?? null), [value])

    return <Dropdown className="w-full" onSelect={onSelect}>
        <Dropdown.Toggle
            className="w-full">
            <input
                value={formattedSelectedItem()}
                placeholder={placeholder}
                readOnly
                className="w-full rounded-lg border-jacarta-100 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400" />
        </Dropdown.Toggle>
        <Dropdown.Menu
            className="dropdown-menu z-10 hidden whitespace-nowrap rounded-xl bg-white py-4 px-2 text-left shadow-xl dark:bg-gray-900">
            <div className="scrollbar-custom flex max-h-48 flex-col overflow-y-auto">
                {
                    items.map(item => <Dropdown.Item
                        unselectable="on"
                        eventKey={item.id}
                        key={item.id}
                        className="dropdown-item flex w-full items-center rounded-xl px-5 py-2 text-left font-display text-sm transition-colors hover:bg-jacarta-50 dark:text-white dark:hover:bg-jacarta-500/[.25] dark:hover:text-white">
                        {builder(item, item.id === selected)}

                        {item.id === selected && <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                            className="ml-4 mb-[3px] h-4 w-4 fill-jacarta-500">
                            <path fill="none" d="M0 0h24v24H0z"></path>
                            <path d="M10 15.172l9.192-9.193 1.415 1.414L10 18l-6.364-6.364 1.414-1.414z"></path>
                        </svg>}
                    </Dropdown.Item>)
                }
            </div>
        </Dropdown.Menu>
    </Dropdown>
}